import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  const faqs = [
    {
      question: "Faut-il prendre rendez-vous ?",
      answer: "Nous recommandons fortement de prendre rendez-vous pour garantir votre créneau, surtout pour les tresses qui demandent plusieurs heures. Cependant, nous acceptons aussi les clients sans rendez-vous selon nos disponibilités."
    },
    {
      question: "Quels moyens de paiement acceptez-vous ?",
      answer: "Nous acceptons les paiements en espèces et par carte bancaire. Pour votre confort, nous disposons d'un terminal de paiement moderne et sécurisé."
    },
    {
      question: "Combien de temps dure une séance de tresses ?",
      answer: "La durée varie selon la complexité : 2h pour des nattes simples, 3-4h pour des box braids, jusqu'à 5-6h pour des créations très élaborées. Nous vous informons de la durée estimée lors de la prise de rendez-vous."
    },
    {
      question: "Proposez-vous des services pour enfants ?",
      answer: "Oui, nous accueillons les enfants avec plaisir ! Pablo a l'habitude de travailler avec les plus jeunes et sait les mettre à l'aise. Tarifs préférentiels pour les moins de 12 ans."
    },
    {
      question: "Utilisez-vous des produits de qualité ?",
      answer: "Absolument ! Nous utilisons exclusivement des produits professionnels adaptés à tous types de cheveux, notamment pour les cheveux afro et métissés. Nos produits respectent la santé de vos cheveux et du cuir chevelu."
    },
    {
      question: "Peut-on annuler ou reporter un rendez-vous ?",
      answer: "Oui, nous comprenons que les imprévus arrivent. Merci de nous prévenir au moins 2h à l'avance par téléphone ou WhatsApp pour annuler ou reporter votre rendez-vous."
    },
    {
      question: "Proposez-vous des forfaits ou promotions ?",
      answer: "Nous proposons régulièrement des offres spéciales : -10% pour les étudiants sur présentation de la carte, forfaits coupe + barbe + soin, et promotions saisonnières. Suivez-nous sur Instagram pour ne rien manquer !"
    },
    {
      question: "Le salon est-il accessible aux personnes à mobilité réduite ?",
      answer: "Nous faisons notre possible pour accueillir tous nos clients. N'hésitez pas à nous contacter avant votre venue pour que nous puissions organiser au mieux votre accueil."
    }
  ];

  return (
    <section className="py-16 bg-secondary/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-primary/10 rounded-full">
              <HelpCircle className="h-12 w-12 text-primary" />
            </div>
          </div>
          <h2 className="heading-lg font-display mb-4">
            Questions <span className="text-gradient">fréquentes</span>
          </h2>
          <p className="text-enhanced max-w-2xl mx-auto">
            Vous avez des questions ? Nous avons les réponses ! 
            Consultez notre FAQ ou contactez-nous directement.
          </p>
        </div>

        <Card className="card-luxury">
          <CardHeader>
            <CardTitle className="text-center text-xl font-display">
              Tout ce que vous devez savoir
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`}
                  className="border border-border/50 rounded-lg px-4"
                >
                  <AccordionTrigger className="text-left font-semibold hover:text-primary transition-colors">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed pt-2">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </CardContent>
        </Card>

        <div className="text-center mt-8">
          <p className="text-muted-foreground mb-4">
            Vous ne trouvez pas la réponse à votre question ?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:+33767632259"
              className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-primary to-primary-glow text-primary-foreground font-semibold rounded-lg hover:shadow-lg hover:shadow-primary/25 transition-all duration-300"
            >
              Appelez-nous
            </a>
            <a 
              href="https://wa.me/33767632259"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold rounded-lg transition-all duration-300"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;